import {hideElem, showElem} from '../utils/dom.ts';
import {svg} from '../svg.ts';

/**
 * This toggle turns a `.container` with a number of `.attached` sections into an accordion.
 *
 * First you need a `.ui.container` with a `.ui.attached.header` as the first child and any number of subsequent
 * `.ui.attached` children. Add the following anywhere in the `.ui.container` (probably the header) to make a toggle:
 *
 * ```
 * <div class="allspice-attached-accordion-toggle" data-expanded>
 *   {{svg "octicon-triangle-right" 18}}
 * </div>
 * ```
 *
 * `data-expanded` signifies that the content should be shown initially, and will also appear when the content is
 * visible in the future (though adding it manually doesn't do anything).
 *
 * When clicked, the toggle will collapse or expand the non-`.header` sections.
 */
export function initAllspiceAttachedAccordionToggle() {
  const toggleEls: NodeListOf<HTMLElement> = document.querySelectorAll('.allspice-attached-accordion-toggle');
  for (const toggleEl of toggleEls) {
    toggleEl.addEventListener('click', handleToggleClick);

    toggleContent(toggleEl, toggleEl.hasAttribute('data-expanded'));
  }
}

function handleToggleClick(ev: MouseEvent) {
  toggleContent(ev.currentTarget as HTMLElement);
}

function toggleContent(toggleEl: HTMLElement, forceExpanded: boolean | null = null) {
  const shouldExpand = forceExpanded ?? !toggleEl.hasAttribute('data-expanded');

  const contentEls = toggleEl.closest('.ui.container').querySelectorAll(`& > .ui.attached:not(.header)`);
  if (shouldExpand) {
    showElem(contentEls);
    toggleEl.setAttribute('data-expanded', '');
    toggleEl.innerHTML = svg('octicon-triangle-down', 18);
  } else {
    hideElem(contentEls);
    toggleEl.removeAttribute('data-expanded');
    toggleEl.innerHTML = svg('octicon-triangle-right', 18);
  }
}
